import { v4 as uuidv4 } from 'uuid';

import { ModuleSlotMap } from '~/modules';
import { ModuleSlotId, ModuleType } from '~/modules/Module.types';

export const modulesConfig: ModuleSlotMap = {
  [ModuleSlotId.MAIN]: [
    {
      id: uuidv4(),
      moduleType: ModuleType.NEGOTIATION_SUPPLIER_CONTACT,
      grid: { size: { xs: 12, md: 4 } },
    },
    {
      id: uuidv4(),
      moduleType: ModuleType.NEGOTIATION_TERMS,
      grid: { size: { xs: 12, md: 6 } },
      props: {
        hasParentForm: true,
      },
    },
    {
      id: uuidv4(),
      moduleType: ModuleType.DEMAND_REQUEST_WIDGET,
      grid: { size: { xs: 12 } },
      props: {
        hasParentForm: true,
      },
      config: {
        externalReference: { hidden: true },
        commodityGroup: { hidden: true },
        lineItems: {
          preferredSupplierId: { hidden: true },
        },
      },
    },
  ],
};
